<script lang="ts" generics="Resource">
  import type {
    ApiCallState,
    MappedCallState,
  } from "$shared/lib/api-parkito2.svelte.ts";
  import {
    Center,
    ErrorCloud,
    Hor,
    Label,
    LoadingIndicator,
    LoadingIndicatorSmall,
    Ver,
  } from "$components";
  interface Props {
    api: ApiCallState<Resource, unknown[]> | MappedCallState<Resource>;
    child: (res: Resource, requestDuration: number) => any;
    error?: string | ((err: string) => any);
    inline?: boolean;
    loadingText?: string;
  }
  const { api, loadingText, error, child, inline = false }: Props =
    $props();
</script>
{#if $api.call.status === "ok"}
  {@render child($api.call.data!, $api.call.requestDuration)}
{:else if $api.call.status === "loading"}
  {#if inline}
    <Hor>
      <LoadingIndicatorSmall visible></LoadingIndicatorSmall>
      {loadingText}
    </Hor>
  {:else}
    <Center>
      <Ver>
        <LoadingIndicator visible></LoadingIndicator>
        {loadingText}
      </Ver>
    </Center>
  {/if}
{:else if $api.call.status === "error"}
  {#if inline}
    {#if typeof error === "function"}
      {@render error($api.call.error.message)}
    {:else if typeof error === "undefined"}
      <Label type="error">Något gick fel: {JSON.stringify($api.call.error)}
      </Label>
    {:else}
      {error}
    {/if}
  {:else}
    <ErrorCloud
      title="Något gick fel, prova att ladda om sidan"
      text={typeof error === "string" ? error : undefined}
    >
      {#if typeof error === "function"}
        {@render error($api.call.error.message)}
      {:else if typeof error === "undefined"}
        {$api.call.error.message}
      {/if}
    </ErrorCloud>
  {/if}
{:else if $api.call.status === "idle"}
  <!-- Should we show something here? -->
{:else}
  <!-- if this ever runs then there is something very wrong -->
{/if}
